import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import {
  editLaboratory
} from "../../actions/laboratory-actions";
import { makeStyles, withStyles } from "@material-ui/styles";
import * as IdKey from "short-uuid";
import EditIcon from "@material-ui/icons/Edit";
import { headers } from "./models";
import EditLaboratoryForm from "./editLaboratoryForm";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { permissionsConstans } from "../../constansPermissions";

const useStyles = makeStyles((theme) => ({
  MuiIconButtonEdgeEnd: {
    order: "-1",
  },
  root: {
    width: "100%",
    marginTop: "10px",
    marginLeft: "10px",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 30,
    width: 30,
    paddingTop: 10,
    paddingRigth: 20,
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "39.6%",
  },
  columnCheckBox: {
    flexBasis: "10%",
  },
  columnEvent: {
    paddingLeft: "20px",
    flexBasis: "7%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    "&:hover": { color: "white", background: "#099F9F" },
  },
}));

const TableLaboratory = ({
  data,
  regionales,
  setOpenEdit,
  openEdit,
  setMessage,
  message,
  setRefresh,
          refresh
}) => {
  const classes = useStyles();
  const id = IdKey.generate();
  const [dataId, setDataId] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const getValueByKey = (object, header) => {
    if (header.child === null) {
      if (header.field) {
        let result = "";
        if (header.field.includes(",")) {
          header.field.split(/\s*,\s*/).forEach(function (myString) {
            result += object[myString] + " ";
          });
          return result;
        }
        return object[header.field];
      }
      return "";
    }
    return object[header.field] !== null
      ? object[header.field][header.child]
      : "";
  };

  const handleClickCloseEdit = () => {
    setMessage({ ...message, open: false });
  };

  const handleClickEdit = async (data) => {
    setMessage({ ...message, open: false });
    const response = await editLaboratory(data);
    if (response && (response?.status === 200 || response?.status === 201)) {
      setMessage({
        description: `La información ha sido modificada`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickCloseEdit(),
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
      setRefresh(!refresh);
      setShowForm(!showForm);
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.sattus !== 403
    ) {
      setMessage({
        description: response?.data?.detail
          ? response?.data?.detail
          : response?.data?.error
          ? response?.data?.error
          : `El laboratorio no ha sido creado, inténtelo nuevamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickCloseEdit(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickCloseEdit(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  };

  const onEdit = (data) => {
    setDataId(data);
    setOpenEdit(!openEdit);
    setShowForm(!showForm);
  };

  const closeEdit = () => {
    setOpenEdit(false);
    setShowForm(!showForm);
  };

  const toggleForm = () => {
    setShowForm(!showForm);
  };

  const validationPermission = () => {
    const state = JSON.parse(localStorage.getItem("state"))
    const module = state?.permissions.find((x)=> x.code === 'LAB')
    if(module?.functionalities?.some((x)=> x === permissionsConstans.LAB_EDITAR)){
        return  <div className={classes.columnEvent}>
          <Tooltip title="Editar" arrow placement="top">
            <EditIcon
              onClick={() => onEdit(data)}
              className={classes.iconEvent}
              style={{
                pointerEvents: "auto",
                fontSize: "40px",
              }}
            />
          </Tooltip>
        </div>
    }
  }

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
      flexDirection: "row-reverse",
    },
  })(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  return (
    <div className={classes.root}>
      <Accordion
        style={{ borderLeftStyle: "solid", borderLeftColor: "#F8DF13" }}
        expanded={showForm}
      >
        <FlippedOrderExpansionPanelSummary
          aria-controls="panel1c-content"
          id={id}
          expandIcon={<ExpandMoreIcon />}
          style={{ pointerEvents: "none" }}
        >
          {headers.initialHeaders.map((header) => (
            <div className={classes.column}>
              <Typography className={classes.heading}>
                {header.title}
              </Typography>
              <Typography className={classes.secondaryHeading}>
                {getValueByKey(data, header)}
              </Typography>
            </div>
          ))}
          {validationPermission()}

        </FlippedOrderExpansionPanelSummary>
        <AccordionDetails className={classes.details}>
          {showForm ? (
            <EditLaboratoryForm
              dataId={dataId}
              regionales={regionales}
              closeEdit={closeEdit}
              handleClickEdit={handleClickEdit}
              setMessage={setMessage}
              message={message}
              toggleForm={toggleForm}
            />
          ) : (
            <div className={classes.rootGrid}>
              <Grid container spacing={3} style={{ margin: "0px 20px" }}>
                {headers?.otherHeaders?.map((header) => (
                  <Grid item xs={2}>
                    <Typography className={classes.heading}>
                      {header.title}
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      {getValueByKey(data, header)}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </div>
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default TableLaboratory;
